import styled, { css } from 'styled-components';

export const Bar = styled.div`
  ${() => css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    margin-top: 16px;
  `}
`;

export const Button = styled.button`
  ${({ theme, $disabled }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    padding: 0;
    border: 1px solid ${$disabled ? theme.v3.colors.neutral[95] : theme.v3.colors.neutral[90]};
    border-radius: ${theme.v3.border.radius.md};
    background-color: ${$disabled ? theme.v3.colors.neutral[98] : theme.v3.colors.neutral[100]};
    color: ${$disabled ? theme.v3.colors.neutral[80] : theme.v3.colors.neutral[20]};
    cursor: ${$disabled ? 'default' : 'pointer'};
    transition: background-color 0.2s, border-color 0.2s, color 0.2s;
    opacity: ${$disabled ? 0.7 : 1};

    &:hover:not(:disabled) {
      background-color: ${theme.v3.colors.neutral[95]};
      border-color: ${theme.v3.colors.neutral[80]};
    }

    &:focus {
      outline: none;
    }

    &:focus-visible {
      box-shadow: 0 0 0 2px ${theme.v3.colors.brand.snappyBlue[40]};
    }
  `}
`;

export const PageIndicator = styled.span`
  ${({ theme }) => css`
    min-width: 60px;
    text-align: center;
    font-size: ${theme.v3.font.sizes.small};
    font-weight: ${theme.v3.font.weights.medium};
    color: ${theme.v3.colors.neutral[30]};
    line-height: 40px;
  `}
`;
